<div>
  <div class="mat-h3">
    Debitor
  </div>
  <ul>
    <li>
      <div class="mat-h3">
        Debitor
      </div>
      <p>
        Geben Sie die Kopfzeile oder den Spaltenindex für die Debitorennummer an.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Debitor-Filter
      </div>
      <p>
        Regulärer Ausdruck um die Debitorennummer aus der Debitoren Spalte zu erkennen.
      </p>
    </li>
  </ul>
</div>
